import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-pagamento-pix-fatura',
  templateUrl: './pagamento-pix-fatura.component.html',
  styleUrls: ['./pagamento-pix-fatura.component.scss']
})
export class PagamentoPixFaturaComponent {
  @Input() pix: any;
  mensagemCopiada = false;

  get imagemQrCode(): string {
    const qrcode = String(this.pix?.qrcode || this.pix?.qrcodeText || '');
    if(!qrcode) return null;
    return /^(data:|https?:\/\/|\/)/i.test(qrcode) ? qrcode : `/api/qrcode?c=${encodeURIComponent(qrcode)}`;
  }

  copie() {
    const valor = String(this.pix?.qrcodeText || '');
    if(!valor) return;
    const campo = document.createElement('textarea');
    campo.style.position = 'fixed';
    campo.style.opacity = '0';
    campo.value = valor;
    document.body.appendChild(campo);
    campo.select();
    document.execCommand('copy');
    document.body.removeChild(campo);
    this.mensagemCopiada = true;
    setTimeout(() => this.mensagemCopiada = false, 5000);
  }
}
